/**
 * `result` shows action results and hides them after a while
 *
 *
 * ## usage
 * ```html
 * <result [status]="status" ></result>
 * ```
 */
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ResultComponentDef } from '@df/ui/api/result.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';

@Component({
    selector: 'result',
    templateUrl: './result.html',
    standalone: true,
    imports: [TranslationModule, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultComponent extends ResultComponentDef {
    @Input()
    fontClass = 's2';
}
